export enum PeOrderStatus {
  waitForApproval = 1,
  active = 2,
  completed = 3,
  canceled = 4,
}
